import React, { useEffect, useState } from "react";
import "./berryCard.scss";
const BerryCard = (props) => {
  const { handleClick, shake } = props;
  return (
    <div
      onClick={handleClick}
      key={shake}
      style={
        shake
          ? {
            animation:
              "shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both",
            transform: "translate3d(0, 0, 0)",
            backfaceVisibility: "hidden",
            perspective: 1000,
            // backgroundColor: props.mainbackgroundColor
            //   ? props.mainbackgroundColor
            //   : "#f3f4f7",
          }
          : {
            // backgroundColor: props.mainbackgroundColor
            //   ? props.mainbackgroundColor
            //   : "#fff",

          }
      }
      className={
        "component-berry-card flipInY relative cursor-pointer" +
        (props.number === undefined ? " spinIn" : "")
      }
    >
      {props.number >= 0 ? (
        <p className="component-berry-card__text">{props.number}</p>
      ) : (
          ""
        )}
      {props.imgSrc ? (
        <img alt="TapFree gameplay" className="img-small" src={props.imgSrc} />
      ) : (
          ""
        )}
      {props.shortBackGroundColor ? (
        <div
          // style={{
          //   backgroundColor: props.mainbackgroundColor
          //     ? props.mainbackgroundColor
          //     : "#f3f4f7",
          // }}
          className="secondary-div"
        ></div>
      ) : (
          ""
        )}
    </div>
  );
};

export default BerryCard;
